export const DecisionActionBarVI = {
    "decisionActionBar": {
        "tab": {
            "detail":"Chi tiết",
            "fileAttach": "Đính kèm"
        },
        "item": {
            "delete": "Xóa",
            "auditing": "Lịch sử hoạt động",
            "update": "Cập nhật",
            "approval": "Duyệt",
            "back": "Quay về"
        },
        "message": {
            "deleteAsk": "Bạn có chắc chắn muốn xóa ",
            "approvalAsk": "Bạn có chắc chắn muốn duyệt quyết định ?"
        }
    }
}